<script>
  import { onMount } from 'svelte';

  function redirectToLogin() {
    window.location.href = '/auth/login'; // ya da istediğiniz başka bir URL'e yönlendirin
  }

  function logoutAndRedirect() {
    // localStorage'dan token'i al
    const token = localStorage.getItem('token');

    // Eğer token varsa, localStorage'dan token'i sil
    if (token) {
      localStorage.clear();
    }

    // Giriş sayfasına yönlendir
    redirectToLogin();
  }

  // Bileşen yüklendiğinde logout ve yönlendirme işlemini gerçekleştir
  onMount(() => {
    logoutAndRedirect();
  });
</script>